import type { NodeCounts } from '../proposed/types';

/**
 * Branch/merge/bowtie indicators (learning spec §7.2). Pure mapping from the
 * proposed per-node counts to a single glyph — fired only for graph-level
 * significance (fan-in/out > 1), never for routine sidelines.
 */

export type NodeIndicator = 'branch' | 'merge' | 'bowtie';

export function nodeIndicator(counts: NodeCounts | undefined): NodeIndicator | null {
  if (counts === undefined) return null;
  const branch = counts.outgoingCount > 1;
  const merge = counts.incomingPathCount > 1;
  if (branch && merge) return 'bowtie';
  if (branch) return 'branch';
  if (merge) return 'merge';
  return null;
}

export const INDICATOR_GLYPHS: Record<NodeIndicator, string> = {
  branch: 'Y',
  merge: '⏶',
  bowtie: '⧓',
};

export const INDICATOR_LABELS: Record<NodeIndicator, string> = {
  branch: 'Branch — this position has multiple continuations',
  merge: 'Transposition — reached by multiple move orders',
  bowtie: 'Branch and transposition',
};
